// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatMessageController from "./chat_message_controller"
application.register("chat-message", ChatMessageController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import ClubPricingController from "./club_pricing_controller"
application.register("club-pricing", ClubPricingController)

import ClubSubscriptionController from "./club_subscription_controller"
application.register("club-subscription", ClubSubscriptionController)

import ClubSubscriptionFormController from "./club_subscription_form_controller"
application.register("club-subscription-form", ClubSubscriptionFormController)

import CollapseToggleController from "./collapse_toggle_controller"
application.register("collapse-toggle", CollapseToggleController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DriverController from "./driver_controller"
application.register("driver", DriverController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import MapController from "./map_controller"
application.register("map", MapController)

import MessageEditController from "./message_edit_controller"
application.register("message-edit", MessageEditController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NewsletterAiController from "./newsletter_ai_controller"
application.register("newsletter-ai", NewsletterAiController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import QuestionFormController from "./question_form_controller"
application.register("question-form", QuestionFormController)

import SearchAutocompleteController from "./search_autocomplete_controller"
application.register("search-autocomplete", SearchAutocompleteController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SelectToggleController from "./select_toggle_controller"
application.register("select-toggle", SelectToggleController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
